export default (value: any) => (typeof value === 'number' ? value : undefined);
